import CountUp from 'react-countup'
import React, {FC, ReactNode} from 'react'

interface Card1Interface {
    bg: 0 | 1
    countUp: number
    description: string
    variant?: 'solid' | 'light'
    afterCount?: ReactNode
}

const Card1: FC<Card1Interface> = ({bg, countUp, description, variant = 'solid', afterCount}) => {

    //
    // const primary = workspace?.color.main
    // const secondary = workspace?.color.second

    const backgroundColor = bg ? "#0094f3bf" : "#e1006dbf"
    const isLight = variant === 'light'

    return (
        <div
            className={`card card-flush h-100 ${isLight ? 'border border-gray-200 shadow-sm' : ''}`}
            style={isLight ? undefined : {backgroundColor}}
        >
            <div className={`card-body d-flex flex-column ${isLight ? 'p-8' : 'p-5'}`}>
                <span className={`${isLight ? 'text-gray-500' : 'text-white'} pt-1 fw-semibold fs-7 mb-3`}>
                    {description}
                </span>
                <div className="d-flex align-items-center flex-wrap gap-3">
                    <span className={`fs-2 fw-bold me-2 lh-1 ls-n2 ${isLight ? 'text-dark' : 'text-white'}`}>
                        <CountUp end={countUp} duration={1.5} />
                    </span>
                    {afterCount}
                </div>
            </div>
        </div>
    )
}

export {Card1}
